import { render, staticRenderFns } from "./SinglePagePDF.vue?vue&type=template&id=832aab00&scoped=true"
import script from "./SinglePagePDF.vue?vue&type=script&lang=js"
export * from "./SinglePagePDF.vue?vue&type=script&lang=js"
import style0 from "./SinglePagePDF.vue?vue&type=style&index=0&id=832aab00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832aab00",
  null
  
)

export default component.exports